export default {
  'discount-form:error:code-internal-usage-not-found': 'Ongeldige couponcode',
  'discount-form:error:code-expired': 'Ongeldige couponcode',
  'discount-form:error:code-exhausted-customer': 'Deze couponcode kan niet meer worden ingewisseld',
  'discount-form:error:code-not-applicable-to-customer':
    'Je kunt deze code op dit moment niet inwisselen. Neem contact op met de klantenservice.',
  'discount-form:error:customer-fidelity-only-new-orders':
    'Deze couponcode is alleen geldig voor nieuwe klanten.',
  'discount-form:error:customer-fidelity-only-old-customers':
    'Deze couponcode is alleen geldig voor bestaande klanten.',
  'discount-form:error:basket-value-too-low':
    'Je winkelmandje is kleiner dan de minimale bestelwaarde voor deze cadeaubon',
};
